export class DraftProfileMin {
  public ProfileId: number = 0;
  public Member: boolean = false;
  public OrgInd: boolean = false;
  public ReportName: string = '';
  public Email: string = '';
  public EmailType: string = '';
  public MemberTypeIconColor: string = '';
}
